import { BankName } from '@/shared';


export const SPOUSE_KINSHIP_CODES = new Set(['HUSBAND', 'WIFE']);

export type MarriageContractDisplayMode =
  | 'marriage_contract_or_notarial_consent'
  | 'marriage_contract_only'
  | 'family_mortgage_spouse_citizenship_rf';

const PROGRAM_TYPES_WITH_SPECIAL_DISPLAY = new Set<string>(['IT', 'FAR_EASTERN', 'OTHER']);

const BANK_DISPLAY_MODE: Partial<Record<BankName, MarriageContractDisplayMode>> = {
  alfabankbalance: 'marriage_contract_or_notarial_consent',
  vtbbankm: 'marriage_contract_or_notarial_consent',
  sovcombank: 'marriage_contract_only'
};

const DEFAULT_DISPLAY_MODE: MarriageContractDisplayMode = 'family_mortgage_spouse_citizenship_rf';

export function getMarriageContractDisplayMode(
  bank: BankName | null | undefined,
  mortgageType: string | null | undefined
): MarriageContractDisplayMode {
  if (!bank || !mortgageType) return DEFAULT_DISPLAY_MODE;

  if (!PROGRAM_TYPES_WITH_SPECIAL_DISPLAY.has(mortgageType)) return DEFAULT_DISPLAY_MODE;

  return BANK_DISPLAY_MODE[bank] ?? DEFAULT_DISPLAY_MODE;
}
